<div class="table-container">
  <table class="table">
    <thead>
      <tr tabindex="0">
        <!-- Selection Column with master checkbox -->
        <th tabindex="0" class="checkbox-column" *ngIf="hasCheckboxes">
          <input type="checkbox" (change)="toggleAll($event)" [checked]="allSelected" />
        </th>
        <th tabindex="0" *ngFor="let col of columns" [ngClass]="{ 'switch-column': col.type === 'switch' }">{{ col.label
          | translate }}</th>
      </tr>
    </thead>
    <tbody *ngIf="paginatedData && paginatedData.length > 0">
      <tr tabindex="0" *ngFor="let row of paginatedData; let i = index">
        <td class="checkbox-column" *ngIf="hasCheckboxes">
          <input type="checkbox" [(ngModel)]="row.selected" (change)="onSelectionChange(row)" />
        </td>
        <td *ngFor="let col of columns" [ngClass]="{ 'switch-column': col.type === 'switch' }">

          <!-- Custom Template -->
          <ng-container tabindex="0" *ngIf="col.type === 'template' && customTemplates[col.templateKey]">
            <ng-container *ngTemplateOutlet="customTemplates[col.templateKey]; context: { $implicit: row }">
            </ng-container>
          </ng-container>
          <!-- Text -->
          <span tabindex="0" *ngIf="!col.type || col.type === 'text'" [title]="row[col.key]" class="truncate-text">
            {{ row[col.key] }}
          </span>
          <!-- Dot -->
          <span *ngIf="col.type === 'dot'" class="colored-dot"
            [ngStyle]="{'background-color': getDotColor(row[col.key])}" [title]="getDotTooltip(row[col.key])"
            matTooltip="getDotTooltip(row[col.key])">
          </span>
          <!-- In your table component -->
          <span tabindex="0" *ngIf="col.type === 'date'">
            {{ row[col.key] | date: 'yyyy-MM-dd' }}
          </span>

          <!-- Badge -->
          <app-risk-index-badge *ngIf="col.type === 'badge'"
            [riskLevel]="row[col.value] != null && row[col.value] !== '' ? row[col.value] : 0"
            [riskString]="col.key === 'codeSubmissions' ? '' : (userInterfaceDisplay === 'Percentage' && row.assignmentType !== 'code' ? '%' : '')"
            [hasDot]="hasDot" [badgeClass]="col.key === 'codeSubmissions' ? row.codeSubmissionsType : getRiskLevelLabel(row[col.key], row.processed, row.isPublic)"
            [hasFlag]="row.hasFlag" [userInterfaceDisplay]="userInterfaceDisplay"
            [originalityRiskFactorHighRisk]="originalityRiskFactorHighRisk"
            [originalityRiskFactorMediumRisk]="originalityRiskFactorMediumRisk" [decimalPlaces]="decimalPlaces"
            [processed]="row.processed" [isPublic]="row.isPublic" [checkPublicAccess]="checkPublicAccess">
          </app-risk-index-badge>


          <!-- Link -->
          <a tabindex="0" *ngIf="col.key === 'originalityLink'" [href]="row[col.linkKey || col.key]" target="_blank"
            class="btn-blue-borderless-md">
            View Report
            <img src="assets/images/icons/link-new-tab.png" alt="report icon" class="report-icon" />
          </a>

          <!-- Toggle Switch -->
          <label *ngIf="col.type === 'switch'" class="switch">
            <input type="checkbox" [checked]="row[col.key]" (change)="onSwitchToggle(row, col.key, $event)" />
            <span class="slider round"></span>
          </label>

          <!-- Actions Column -->
          <div *ngIf="col.type === 'actions'" class="action-links">
            <a href="#" (click)="onEdit(row)" class="action-link">
              <img src="assets/images/icons/edit.png" alt="Edit" class="action-icon" />
              Edit
            </a>
            <span class="divider">|</span>
            <a href="#" (click)="onDelete(row)" class="action-link">
              <img src="assets/images/icons/Delete.png" alt="Delete" class="action-icon" />
              Delete
            </a>
          </div>

        </td>
      </tr>
    </tbody>
  </table>
</div>
